export default window._cmsContent['solar/flat-roof-check']